<template>
  <div class="filters-button" :class="{ visible }">
    <div class="prefix" />
    <div v-if="count" class="count">{{ count }}</div>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  count: {
    type: Number,
    default: 0,
  },
  visible: {
    type: Boolean,
    required: true,
  },
});
</script>

<style scoped lang="scss">
.filters-button {
  display: flex;
  gap: 8px;
  cursor: pointer;
  flex-flow: row nowrap;
  align-items: center;
  color: $achromatic-black;
  transition: color 0.1s;
  background: $achromatic-card-bg;
  border-radius: 4px;
  padding: 8px 12px;
  font-weight: 450;
  font-size: 12px;
  line-height: 16px;
  position: relative;

  .prefix {
    height: 16px;
    min-width: 16px;
    mask: url('/static/images/filter-slider.svg') center / contain no-repeat;
    background-color: $achromatic-black;
  }

  .count {
    position: absolute;
    top: -7px;
    right: -1px;
    display: flex;
    height: 12px;
    min-width: 16px;
    padding: 7px 5px;
    border: 2px solid $white;
    border-radius: 10px;
    background: #fb2386;
    align-items: center;
    font-size: 8px;
    line-height: 8px;
    color: $white;
    font-weight: 800;
  }

  &:hover,
  &:active,
  &:focus {
    color: $achromatic-black !important;
    user-select: none !important;
    .prefix {
      background-color: $achromatic-black !important;
      user-select: none !important;
    }
  }
  @include lg-block {
    display: none;
  }
}
</style>
